<template>
</template>

<script>

    const envParams = ['sessionId', "other"];

    const pageParam = "page";


    export default {
        name: "router",
        data(){
            return{
                
            }
        },
        mounted(){
            let routerUrl = window.location.href ;
            let params = this.getParams(routerUrl);
            let page = params['page'];
            let sessionId = params['sessionId']
            
            if(sessionId==''||sessionId=='undefined'||undefined==null){
                delete params.sessionId;
            }
            let flag=params['flag'] == 'true' ? 'true' : 'false'
            
            localStorage.setItem('flag', flag);
            localStorage.setItem('sessionId', sessionId);
            delete params.page;
            delete params.sessionId;
            if (page == undefined || page == '') {
                console.error("page为空,转发错误");
            }
            this.$router.push({name: page, params: params});
        },
        methods:{
            getParams(url){
                let params = {};
                if (url != undefined) {
                    let str = url.split("?")[1];
                    let paramStrArr = str.split("&");

                    for (let i = 0; i < paramStrArr.length; i++) {
                        let obj = paramStrArr[i].split("=");
                        params[obj[0]] = obj[1];
                    }
                }
                return params;
            }
        },
    }


</script>

<style scoped>

</style>